import * as React from "react";
import CustomTypography from "../../../../../widgets/typography";
import { ContentHeaderProps } from "../types";

export default function ContentHeaderHint({
  title,
}: ContentHeaderProps): React.JSX.Element {
  return <CustomTypography variant="body1">{title}</CustomTypography>;
}
